import { Link } from "react-router-dom"
import CustomBootstrapInlineTable from "components/Common/CustomInlineTable/CustomBootstrapInlineTable"
import CustomBootstrapTableAsync from "components/Common/CustomTable/CustomBootstrapTableAsync"
import { ModuleIds, SAMPLES_DELIVERY_TYPE } from "constant"
import { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { CustomSID, LinkCustom } from "components/Common"

let tests = []

const TestTable = ({
  onSelect,
  onSelectAll,
  data,
  onEdit,
  onDelete,
  t,
  model,
  loading,
  onChangeRemark,
  delivery,
  ...rest
}) => {

  const [columnExpand, setColumnExpand] = useState([])
  const [testRequestTests, setTestRequestTests] = useState([])

  useEffect(() => {
    const test = []
    data.forEach((item, index) => {
      if (item.profileCode) {
        const groupTest = test.find(element =>
          element.profileCode === item.profileCode
          && element.sid === item.sid
          && element.patientId === item.patientId
        )
        if (groupTest) {
          groupTest.children.push(item)
        } else {
          test.push({
            id: index + 1,
            profileCode: item.profileCode,
            profileName: item.profileName,
            sampleType: item.sampleType,
            sid: item.sid,
            patientId: item.patientId,
            patientName: item.patientName,
            reasonName: item.reasonName,
            confirmedUserName: item.confirmedUserName,
            confirmedTime: item.confirmedTime,
            children: [item]
          })
        }
      } else {
        item.id = index + 1
        test.push(item)
      }
    })
    tests = test
    setTestRequestTests([...test])
  }, [data])

  const columns = [
    {
      dataField: "id",
      text: "#",
      hidden: true,
      searchable: false,
    },
    {
      dataField: "deliveryId",
      text: "deliveryId",
      hidden: true,
      searchable: false,
    },
    {
      dataField: "",
      text: "#",
      headerStyle: { width: "60px" },
      searchable: false,
      formatter: (cellContent, sample, index) => index + 1
    },
    {
      dataField: "testName",
      text: t("Test Name"),
      style: { width: '500px' },
      formatter: (cellContent, code, index) => (
        <>
          {
            (code.children && code.children.length > 0) &&
            <div>
              <i className="fas fa-arrow-right"
                style={code.children && code.children.length > 0 ? { color: "#556ee6" } : {}}></i>
              <span className="px-2" style={{ fontWeight: 'bold' }}>{code.profileName}</span>
            </div>
          }
          {
            (!code.children) &&
            <div>
              <span className="px-2">{code.testName}</span>
            </div>
          }
        </>
      ),
    },
    {
      dataField: "testCode",
      text: t("Test Code"),
      searchable: false,
      style: { width: SAMPLES_DELIVERY_TYPE.Cancelation ? '150px' : '260px' },
      formatter: (cellContent, code, index) => {
        return (
          <>
            {
              (code.children && code.children.length > 0) &&
              <span >{code.profileCode}</span>
            }
            {
              (!code.children) &&
              <span >{code.testCode}</span>
            }
          </>
        )
      },
    },
    {
      dataField: "sid",
      text: t("SID"),
      style: { width: '200px' },
      formatter: (cellContent, item, index) => {
        return <CustomSID
          sid={item.sid}
          textOnly={true}
        />
      }
    },
    {
      dataField: "subSID",
      text: t("SubSID"),
      style: { width: '120px' },
      formatter: (cellContent, item, index) => cellContent || ''
    },
    {
      dataField: "patientName",
      text: t("Patient"),
      formatter: (cellContent, sample, index) => (
        <Link to={`/Patient/${sample.patientId}/view`} target="_blank">
          {cellContent}
        </Link>
      ),
    }
  ]

  const columnChild = (rowIndex) => [
    {
      dataField: "id",
      text: "#",
      hidden: true,
      searchable: false,
    },
    {
      dataField: "deliveryId",
      text: "deliveryId",
      hidden: true,
      searchable: false,
    },
    {
      dataField: "",
      text: "#",
      headerStyle: { width: "60px" },
      searchable: false,
      formatter: (cellContent, sample, index) => `${rowIndex + 1}.${index + 1}`
    },
    {
      dataField: "deliveryId",
      text: "deliveryId",
      hidden: true,
      searchable: false,
    },
    {
      dataField: "testName",
      text: t("Test Name"),
      style: { width: '500px' },
      formatter: (cellContent, code, index) => (
        <>
          {
            (code.children && code.children.length > 0) &&
            <div>
              <i className="fas fa-arrow-right"
                style={code.children && code.children.length > 0 ? { color: "#556ee6" } : {}}></i>
              <span className="px-2" style={{ fontWeight: 'bold' }}>{code.profileName}</span>
            </div>
          }
          {
            (!code.children) &&
            <div>
              <span className="px-2">{code.testName}</span>
            </div>
          }
        </>
      ),
    },
    {
      dataField: "testCode",
      text: t("Test Code"),
      searchable: false,
      style: { width: SAMPLES_DELIVERY_TYPE.Cancelation ? '150px' : '260px' },
      formatter: (cellContent, code, index) => {
        return (
          <>
            {
              (code.children && code.children.length > 0) &&
              <span >{code.profileCode}</span>
            }
            {
              (!code.children) &&
              <span >{code.testCode}</span>
            }
          </>
        )
      },
    },
    {
      dataField: "sid",
      text: t("SID"),
      style: { width: '200px' },
      formatter: (cellContent, item, index) => {
        return <CustomSID
          sid={item.sid}
          textOnly={true}
        />
      }
    },
    {
      dataField: "subSID",
      text: t("SubSID"),
      style: { width: '120px' },
      formatter: (cellContent, item, index) => cellContent || ''
    },
    {
      dataField: "patientName",
      text: t("Patient"),
      formatter: (cellContent, sample, index) => (
        // <Link to={`/Patient/${sample.patientId}/view`} target="_blank">
        //   {cellContent}
        // </Link>
        <LinkCustom resource={ModuleIds.Patient} link={`/Patient/${sample.patientId}/view`} content={cellContent} />
      ),
    }
  ]


  const UpdateExpandColumn = (code, row) => {
    let children = row['children'] || []
    if (children.length == 0)
      return;
    let result = columnExpand
    let ind = result.findIndex(x => x == code)
    if (ind < 0) {
      result.push(code)
    }
    else {
      result = result.filter(x => x != code)
    }
    setColumnExpand([...result])
  }

  const getNonExpand = () => {
    let res = []
    res = testRequestTests.filter(x => !x.children || x.children.length == 0).map(x => x.id)
    res.push(-1)
    return res
  }

  const expandRow = {
    renderer: (row, rowIndex) => {
      return (
        <div className="table-expand-custom-header table-expand-custom">
          <CustomBootstrapInlineTable
            columns={columnChild(rowIndex)}
            data={row.children}
            isScrollable
            expandRow={expandRow}
            loading={loading}
            isTableScrollX={true}
            searchText={""}
            draggable
            keyField={"id"}
            {...rest}
          />
        </div>
      )
    },
    nonExpandable: getNonExpand(),
    parentClassName: (isExpanded, row, rowIndex) => {
      return columnExpand.findIndex(x => x == row.id) >= 0 ? 'row-expanded' : 'row-noneexpanded'
    },
    expanded: columnExpand
  }


  return (
    <div className="table-expand-custom table-delivery">
      <CustomBootstrapTableAsync
        columns={columns}
        showSelectRow={false}
        data={testRequestTests}
        expandRow={expandRow}
        isEnableLoadInfo={true}
        paging={{
          dataSize: testRequestTests.length,
          page: 1,
          size: testRequestTests.length,
          totalPages: 0
        }}
        customSize={testRequestTests.length}
        keyField={"id"}
        updatedTime={new Date()}
        onRowClick={(e, row, rowIndex) => {
          UpdateExpandColumn(row.id, row)
        }}
        {...rest}
      />
    </div>
  )
}

export default withTranslation(["deliveryPage", "common"])(TestTable)
